<ngb-pagination [collectionSize]="collectionSize" [(page)]="page" [pageSize]="perpage"
    (pageChange)="search()"></ngb-pagination>
<div class="table-responsive">
    <table class="table">
        <thead>
            <tr>
                <th><span>CONDUCTORES</span></th>
                <th>
                    <div class="btn-group float-end" role="group" *ngIf="level==99 || level==1">
                        <button *ngIf="!hiddeAdd" type="button" class="btn btn-sm btn-round  btn-primary"
                            (click)="openModal(selectDriver,'sm')"><i class="fa-solid fa-circle-plus"></i>
                        </button>
                    </div>
                </th>
            </tr>
        </thead>
        <tbody style="max-height: 300px;">
            <tr *ngFor="let item of items">
                <td>
                    <span>{{item.name | uppercase}}</span> &nbsp;
                    <span>{{item.lastname | uppercase}}</span><br>
                    <span>{{item.rut | uppercase}}</span>
                </td>
                <td>
                    <div class="btn-group center" role="group" aria-label="Basic mixed styles example"
                        *ngIf="level==99 || level==1">
                        <button type="button" class="btn  text-danger" (click)="openDelete(item,remove,'sm')">
                            <i class="fa-solid fa-trash"></i>

                        </button>
                    </div>

                </td>
            </tr>
            <tr *ngIf="!items">
                <td colspan="7" class="fw-lighter text-muted">No se encontraron registros</td>
            </tr>
        </tbody>
    </table>
</div>
<ngb-pagination [collectionSize]="collectionSize" [(page)]="page" [pageSize]="perpage"
    (pageChange)="search()"></ngb-pagination>

<ng-template #remove let-c="close" let-d="dismiss">

    <div class="modal-header">
        <h4 class="modal-title" id="modal-basic-title">Eliminar registro</h4>
        <button type="button" class="close" aria-label="Close" (click)="d('Cross click')">
            <span aria-hidden="true">&times;</span>
        </button>
    </div>
    <div class="modal-body">
        <p>¿Esta seguro que desea eliminar este registro?</p>
    </div>
    <div class="modal-footer">
        <button type="button" class="btn btn-outline-secondary" (click)="d('Cross click')">No</button>
        <button type="button" ngbAutofocus class="btn btn-danger" (click)="delete();d('Cross click')">Si</button>
    </div>

</ng-template>

<ng-template #selectDriver let-c="close " let-d="dismiss">
    <div class="modal-body shadow-lg">
        <form [formGroup]="formSelected">
            <label class="small mb-1" for="parking">PERSONAS AUTORIZADAS</label>
            <div class="input-group">
                <select type="text" class="form-control text-uppercase" formControlName="drivers_id" >
                    <option value="0">SELECCIONE</option>
                    <option *ngFor="let item of driversAvailables" [value]="item?.id">{{item?.name}} {{item?.lastname}}
                        ({{item?.type}})</option>
                </select>
                <button class="btn btn-primary" (click)="openSelected(add,'sm')"><i class="fa-solid fa-plus"></i></button>
            </div>
        </form>
    </div>
    <div class="modal-footer">
        <button type="button" class="btn btn-warning" aria-label="Close" (click)="d('Cross click')"> Cerrar
            <span aria-hidden="true">&times;</span>
        </button>
    </div>
</ng-template>

<ng-template #add let-c="close " let-d="dismiss">
    <div class="modal-body shadow-lg">
        <app-add-driver [driver]="selected" [storesId]="storesId" [carsId]="car?.id" (success)="get();d('Cross click')" />
    </div>
    <div class="modal-footer">
        <button type="button" class="btn btn-warning" aria-label="Close" (click)="d('Cross click')"> Cerrar
            <span aria-hidden="true">&times;</span>
        </button>
    </div>
</ng-template>
